/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  FeeHandlerRouter,
  FeeHandlerRouterInterface,
} from "../FeeHandlerRouter";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "IncorrectFeeSupplied",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "FeeCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "FeeDistributed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "whitelistAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isWhitelisted",
        type: "bool",
      },
    ],
    name: "WhitelistChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_domainResourceIDToFeeHandlerAddress",
    outputs: [
      {
        internalType: "contract IFeeHandler",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_whitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getRoleMemberIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feeHandlerType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "contract IFeeHandler",
        name: "handlerAddress",
        type: "address",
      },
    ],
    name: "adminSetResourceHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "whitelistAddress",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isWhitelisted",
        type: "bool",
      },
    ],
    name: "adminSetWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "depositData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "collectFee",
    outputs: [],
    stateMutability: "payable",
    type: "function",
    payable: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "depositData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "calculateFee",
    outputs: [
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
];

const _bytecode =
  "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";

type FeeHandlerRouterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: FeeHandlerRouterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class FeeHandlerRouter__factory extends ContractFactory {
  constructor(...args: FeeHandlerRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "FeeHandlerRouter";
  }

  deploy(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FeeHandlerRouter> {
    return super.deploy(
      bridgeAddress,
      overrides || {}
    ) as Promise<FeeHandlerRouter>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(bridgeAddress, overrides || {});
  }
  attach(address: string): FeeHandlerRouter {
    return super.attach(address) as FeeHandlerRouter;
  }
  connect(signer: Signer): FeeHandlerRouter__factory {
    return super.connect(signer) as FeeHandlerRouter__factory;
  }
  static readonly contractName: "FeeHandlerRouter";
  public readonly contractName: "FeeHandlerRouter";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FeeHandlerRouterInterface {
    return new utils.Interface(_abi) as FeeHandlerRouterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FeeHandlerRouter {
    return new Contract(address, _abi, signerOrProvider) as FeeHandlerRouter;
  }
}
